/* PupHush — global storefront JS. Additive & safe (failure degrades gracefully).
   (1) cart free-shipping bar + upsell (drawer + cart page)
   (2) site-wide announcement bar
   (3) product page: AJAX add→drawer (Section Rendering API), dynamic sticky price, honest 4th-of-July countdown */
(function(){
  var THRESHOLD = 3500; // $35 in cents
  function money(c, cur){ var a = (c/100).toFixed(2); if(cur === 'EUR'){ return '€' + a.replace('.', ','); } var s = { USD:'$', GBP:'£', CAD:'$', AUD:'$' }[cur] || '$'; return s + a; }
  var deb, suppress = false, rc = 0, rw = 0;

  /* ---------- (1) cart free-shipping bar + upsell ---------- */
  function build(cart){
    var total = cart.total_price, remaining = THRESHOLD - total;
    var pct = Math.max(4, Math.min(100, Math.round(total / THRESHOLD * 100)));
    var key = total + '|' + cart.item_count;
    var msg = remaining > 0
      ? "You’re <b>" + money(remaining, cart.currency) + "</b> away from <b>FREE shipping</b> 🚚"
      : "🎉 You’ve unlocked <b>FREE shipping!</b>";
    var up = cart.item_count < 2
      ? "<p class='ph-upsell'>💜 Tip: add a 2nd snood to <b>save 20%</b> — one on, one in the wash.</p>"
      : "";
    return { key: key, html: "<p class='ph-fsbar__msg" + (remaining > 0 ? "" : " ph-fsbar__msg--done") + "'>" + msg + "</p><div class='ph-fsbar__track'><div class='ph-fsbar__fill' style='width:" + pct + "%'></div></div>" + up };
  }
  function place(cart){
    var wrappers = [].slice.call(document.querySelectorAll('.cart-items__wrapper'));
    if(!cart || cart.item_count === 0){ [].slice.call(document.querySelectorAll('.ph-fsbar')).forEach(function(b){ b.remove(); }); return; }
    var b = build(cart);
    suppress = true; // our own DOM writes must not re-trigger the mutation observer
    try {
      wrappers.forEach(function(w){
        if(!w.parentNode) return;
        var prev = w.previousElementSibling;
        var bar = (prev && prev.classList && prev.classList.contains('ph-fsbar')) ? prev : null;
        if(bar && bar.getAttribute('data-key') === b.key) return;
        if(!bar){ bar = document.createElement('div'); bar.className = 'ph-fsbar'; w.parentNode.insertBefore(bar, w); }
        bar.setAttribute('data-key', b.key); bar.innerHTML = b.html;
      });
    } catch(e){}
    setTimeout(function(){ suppress = false; }, 80);
  }
  function refresh(){
    var now = Date.now();
    if(now - rw > 3000){ rw = now; rc = 0; }
    if(++rc > 8) return; // circuit breaker: never more than 8 cart fetches per 3s
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(place).catch(function(){});
  }
  function onMutate(){ if(suppress) return; clearTimeout(deb); deb = setTimeout(refresh, 250); }

  /* ---------- (2) site-wide announcement bar (only where the in-section one is absent) ---------- */
  function announce(){
    if(document.getElementById('ph-announce') || document.querySelector('.ph-bar, .phh-bar')) return;
    var header = document.querySelector('#header-group') || document.querySelector('header-component') || document.querySelector('header');
    if(!header || !header.parentNode) return;
    var bar = document.createElement('div'); bar.id = 'ph-announce';
    bar.setAttribute('style', 'background:#28223C;color:#EDE9F6;text-align:center;font:500 13px/1.4 Inter,-apple-system,"Segoe UI",sans-serif;padding:11px 16px;letter-spacing:.2px');
    bar.innerHTML = "✨ Free shipping over €35 · <b style=\"color:#F4B97E;font-weight:600\">Order early for the 4th of July</b>";
    header.parentNode.insertBefore(bar, header.nextSibling);
  }

  /* ---------- (3) product page enhancements ---------- */
  function productEnhance(){
    var form = document.getElementById('ph-form');
    if(!form) return;

    // dynamic sticky-bar price (follows the selected pack)
    function syncSticky(){
      var sel = document.querySelector('#ph-offer .ph-opt.sel'), sp = document.getElementById('ph-sp');
      if(!sel || !sp) return;
      var pr = sel.querySelector('.pr'); if(!pr) return;
      var sEl = pr.querySelector('s');
      var now = (pr.lastChild ? pr.lastChild.textContent : pr.textContent) || '';
      sp.textContent = now.trim();
      var small = sp.parentNode.querySelector('small');
      if(small){ if(sEl){ small.textContent = sEl.textContent; small.style.display = ''; } else { small.style.display = 'none'; } }
    }
    [].slice.call(document.querySelectorAll('#ph-offer .ph-opt')).forEach(function(o){ o.addEventListener('click', function(){ setTimeout(syncSticky, 0); }); });
    syncSticky();

    // honest 4th-of-July ordering countdown (auto-hides outside the 30-day window)
    if(!document.querySelector('.ph-countdown')){
      var n = new Date(), deadline = new Date(n.getFullYear(), 5, 20, 23, 59, 59);
      var days = Math.ceil((deadline - n) / 86400000);
      if(days > 0 && days <= 30){
        var el = document.createElement('div'); el.className = 'ph-countdown';
        el.setAttribute('style', 'display:flex;align-items:center;justify-content:center;gap:7px;margin:14px 0 2px;font-size:13px;font-weight:600;color:#574A93;background:#EFEDF9;border-radius:11px;padding:10px 14px;font-family:Inter,-apple-system,"Segoe UI",sans-serif;line-height:1.3');
        el.innerHTML = '🎆 <span>Only <b>' + days + ' day' + (days === 1 ? '' : 's') + '</b> left to order for guaranteed <b>4th-of-July delivery</b></span>';
        var anchor = document.getElementById('ph-offer');
        if(anchor && anchor.parentNode){ anchor.parentNode.insertBefore(el, anchor.nextSibling); }
      }
    }

    // AJAX add → re-render cart drawer + header badge via Section Rendering API → open. Fallback = native submit.
    form.addEventListener('submit', function(e){
      var cd = document.querySelector('cart-drawer-component');
      if(!cd || typeof cd.open !== 'function') return; // let native submit run
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      if(btn){ btn.style.opacity = '.7'; btn.style.pointerEvents = 'none'; }
      function restore(){ if(btn){ btn.style.opacity = ''; btn.style.pointerEvents = ''; } }
      var secEl = cd.closest('[id^="shopify-section-"]');
      var sec = secEl ? secEl.id.replace('shopify-section-', '') : null;
      var fd = new FormData(form);
      if(sec){ fd.append('sections', sec); }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
        .then(function(data){
          try{
            var html = (data && data.sections && sec) ? data.sections[sec] : null;
            if(html){
              suppress = true; // the swap is a big mutation — don't let it cascade through the observer
              var doc = new DOMParser().parseFromString(html, 'text/html');
              ['cart-items-component', 'cart-icon'].forEach(function(selr){
                var fresh = doc.querySelectorAll(selr), live = document.querySelectorAll(selr);
                for(var i = 0; i < live.length && i < fresh.length; i++){ try { live[i].innerHTML = fresh[i].innerHTML; } catch(err){} }
              });
              setTimeout(function(){ suppress = false; }, 150);
            }
          } catch(err){}
          if(cd && cd.open) cd.open();
          setTimeout(refresh, 300); // re-insert the free-shipping bar into the freshly rendered drawer (place is suppress-guarded)
          restore();
        })
        .catch(function(){ restore(); try { form.submit(); } catch(e){ window.location.href = '/cart'; } });
    });
  }

  function init(){
    announce();
    productEnhance();
    var drawer = document.querySelector('cart-drawer-component, .cart-drawer');
    if(drawer){ try { new MutationObserver(onMutate).observe(drawer, { childList: true, subtree: true }); } catch(e){} }
    var isCartPage = /\/cart(\/|$|\?)/.test(location.pathname) || (document.body.className || '').indexOf('template-cart') !== -1 || !!document.querySelector('.cart-page');
    if(isCartPage){ var m = document.querySelector('main') || document.body; try { new MutationObserver(onMutate).observe(m, { childList: true, subtree: true }); } catch(e){} }
    ['cart:refresh','cart:update','cart:change','cart:added'].forEach(function(ev){ document.addEventListener(ev, refresh); });
    refresh();
  }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
